import { memo } from 'react'
import { useSelector } from 'react-redux'
import PnlView from '../payoffChart/PnlView'
import { selectTargetPnl } from '../../selectors/strategyBuilder'

const LivePayoffTargetPnl = () => {
    const targetPnl = useSelector(selectTargetPnl)
    return <PnlView profit={targetPnl ?? 0} />
}

export default memo(LivePayoffTargetPnl)
